<div class="container-fluid form-container">
  <div class="container px-md-1">
    <div class="row justify-content-center">
      <div class="col-lg-9 col-md-11 col-12">
        <div class="contact-card p-md-5">
        <!-- Decorative arrows, sticking out beyond the top-left corner -->
        <img
          class="contact-card__arrows"
          src="assets/images/rows.png"
          alt=""
          aria-hidden="true"
        />
        <!-- Title and Subtitle Section -->
        <div *ngIf="showTitles" class="contact-card__head text-center mb-4">
          <h5
            class="contact-card__title"
            [style.text-align]="alignTextBlock"
            [style.color]="titlesColor"
            [style.margin-bottom]="'0.5rem'"
          >
            {{ title }}
          </h5>

          <div
            *ngIf="subtitle"
            [style.text-align]="alignTextBlock"
            [style.color]="secondaryColor"
            [style.margin-bottom]="'2rem'"
            class="subtitle-text"
          >
            {{ subtitle }}
          </div>

          <!-- Letter icon to the right of the title/subtitle -->
          <img
            class="contact-card__letter"
            src="assets/images/letter.png"
            alt=""
            aria-hidden="true"
          />
        </div>

        <!-- Form Section -->
        <form class="block-form">
          <div class="row">
            <ng-container *ngFor="let field of formFields; let i = index">
            <!-- Personal-data section heading (after the "Nivel de interés" dropdown) -->
            <div *ngIf="i === 1" class="col-12 mb-2">
              <h6 class="block-form__section-title">{{ dataSectionTitle }}</h6>
            </div>
            <div
              class="col-12 mb-3"
              [ngClass]="field.half ? 'col-md-6' : 'col-12'"
            >
              <!-- Input Field -->
              <div *ngIf="field.type === 'input'" class="form-group">
                <label
                  *ngIf="field.name"
                  [for]="'field-' + field.name"
                  class="form-label"
                >
                  {{ field.name }}
                  <span *ngIf="field.required" class="text-danger">*</span>
                </label>
                <input
                  [id]="'field-' + field.name"
                  type="text"
                  class="form-control px-3"
                  [placeholder]="field.placeholder || ''"
                  [(ngModel)]="values[field.name]"
                  [name]="field.name"
                  [ngModelOptions]="{ standalone: true }"
                />
              </div>

              <!-- Long Text Field -->
              <div *ngIf="field.type === 'longtext'" class="form-group">
                <label
                  *ngIf="field.name"
                  [for]="'field-' + field.name"
                  class="form-label"
                >
                  {{ field.name }}
                  <span *ngIf="field.required" class="text-danger">*</span>
                </label>
                <textarea
                  [id]="'field-' + field.name"
                  class="form-control px-3"
                  rows="4"
                  [placeholder]="field.placeholder || ''"
                  [(ngModel)]="values[field.name]"
                  [name]="field.name"
                  [ngModelOptions]="{ standalone: true }"
                ></textarea>
              </div>

              <!-- Dropdown Static Field -->
              <div *ngIf="field.type === 'dropdown_static'" class="form-group">
                <label
                  *ngIf="field.name"
                  [for]="'field-' + field.name"
                  class="form-label"
                >
                  {{ field.name }}
                  <span *ngIf="field.required" class="text-danger">*</span>
                </label>
                <select
                  [id]="'field-' + field.name"
                  class="form-control form-select px-3"
                  [(ngModel)]="selectedLevelId"
                  [name]="field.name"
                  [ngModelOptions]="{ standalone: true }"
                >
                  <option [ngValue]="null">{{ field.placeholder || '' }}</option>
                  <option
                    *ngFor="let level of levels"
                    [ngValue]="level.id"
                  >
                    {{ level.name }}
                  </option>
                </select>
              </div>
            </div>
            </ng-container>
          </div>

          <!-- reCAPTCHA centered, Submit Button below it -->
          <div class="row">
            <div class="col-12 d-flex flex-column align-items-center">
              <re-captcha
                [siteKey]="recaptchaSiteKey"
                (resolved)="onCaptchaResolved($event)"
              ></re-captcha>
              <button
                type="button"
                class="btn btn-lg px-5 block-form__submit mt-3"
                [disabled]="!recaptchaToken || submitting"
                (click)="onSubmit()"
              >
                <span>
                  {{ submitting ? 'Enviando...' : (buttonText || '') }}
                </span>
              </button>
            </div>
          </div>

          <!-- Additional Buttons (if configured) -->
          <div
            class="row mt-5"
            *ngIf="btn1Active || btn2Active"
          >
            <div class="col-12 text-center">
                <div
                class="d-flex flex-wrap gap-3"
                [ngClass]="{
                  'justify-content-center': btn1Align === 'center',
                  'justify-content-start': btn1Align === 'left',
                  'justify-content-end': btn1Align === 'right'
                }"
                >
                <a
                  *ngIf="btn1Active"
                  [href]="btn1Link"
                  class="btn btn-info btn-flex mr-3 mt-md-0 mt-2 col-auto"
                >
                  {{ btn1Es }}
                  <i class="fa fa-arrow-right mx-2"></i>
                </a>
                <a
                  *ngIf="btn2Active"
                  [href]="btn2Link"
                  class="btn-info-2 mr-2 mt-md-0 mt-2 col-auto py-2 px-0"
                  [style.color]="linkColor"
                >
                  {{ btn2Es }}
                  <i class="fa fa-arrow-right mx-2"></i>
                </a>
                </div>
            </div>
          </div>
        </form>
        </div>
      </div>
    </div>
  </div>
</div>
